"use client";
import { createActionButton, } from "../../utils/createActionButton.js";
import { useCallback } from "react";
import { useAuiState, useAui } from "@assistant-ui/store";
export const useComposerSend = () => {
    const aui = useAui();
    const disabled = useAuiState((s) => s.thread.isRunning || !s.composer.isEditing || s.composer.isEmpty);
    const callback = useCallback(() => {
        aui.composer().send();
    }, [aui]);
    if (disabled)
        return null;
    return callback;
};
/**
 * A button component that sends the current message in the composer.
 *
 * This component automatically handles the send functionality and is disabled
 * when sending is not available (e.g., when the thread is running, the composer
 * is empty, or not in editing mode).
 *
 * @example
 * ```tsx
 * <ComposerPrimitive.Send>
 *   Send Message
 * </ComposerPrimitive.Send>
 * ```
 */
export const ComposerPrimitiveSend = createActionButton("ComposerPrimitive.Send", useComposerSend);
//# sourceMappingURL=ComposerSend.js.map